import get from 'lodash/get';
import set from 'lodash/set';
import unset from 'lodash/unset';

import { envConfig } from '../../../../config';
import { getJsonObject, getJsonString } from '../../utils/json-utils/json.util';
import { ILocalStorageService } from '../models/local-storage.model';

export const APP_NAME = envConfig.app.name;

const localStorageService: ILocalStorageService = {
  clear: (): void => {
    window.localStorage.clear();
  },
  clearAppState: (): void => {
    window.localStorage.removeItem(APP_NAME);
  },
  get: (path: string): string | Record<string, unknown> | null => {
    return get(localStorageService.read(), path, null);
  },
  read: (): { [key: string]: string | null } | null => {
    const appLocalData = window.localStorage.getItem(APP_NAME);
    return appLocalData ? getJsonObject(appLocalData) : null;
  },
  remove: (path: string): void => {
    const appLocalDataObject = localStorageService.read();
    unset(appLocalDataObject, path);
    localStorageService.write(appLocalDataObject);
  },
  set: <Entity>(path: string, item: Entity): void => {
    const localStorage = set(localStorageService.read() || {}, path, item);
    localStorageService.write(localStorage);
  },
  write: <Entity>(dataObject: Entity): void => {
    const appLocalData = getJsonString(dataObject);
    window.localStorage.setItem(APP_NAME, appLocalData);
  },
};

export default localStorageService;
